//IMPORT MORE ICONS IF NEEDED IN THE FUTURE
import ARE from "../icons/ARE.svg";
import AUS from "../icons/AUS.svg";
import BGR from "../icons/BGR.svg";
import CAN from "../icons/CAN.svg";
import CHE from "../icons/CHE.svg";
import CHN from "../icons/CHN.svg";
import CZE from "../icons/CZE.svg";
import DNK from "../icons/DNK.svg";
import EUR from "../icons/EUR.svg";
import GBR from "../icons/GBR.svg";
import HKG from "../icons/HKG.svg";
import HRV from "../icons/HRV.svg";
import HUN from "../icons/HUN.svg";
import ISR from "../icons/ISR.svg";
import JPN from "../icons/JPN.svg";
import KOR from "../icons/KOR.svg";
import MEX from "../icons/MEX.svg";
import NOR from "../icons/NOR.svg";
import NZL from "../icons/NZL.svg";
import POL from "../icons/POL.svg";
import ROU from "../icons/ROU.svg";
import RUS from "../icons/RUS.svg";
import SAU from "../icons/SAU.svg";
import SGP from "../icons/SGP.svg";
import SWE from "../icons/SWE.svg";
import TUR from "../icons/TUR.svg";
import USA from "../icons/USA.svg";
import ZAF from "../icons/ZAF.svg";

const currencyMap: Record<string, string> = {
  AED: ARE,
  AUD: AUS,
  BGN: BGR,
  CAD: CAN,
  CHF: CHE,
  CNH: CHN,
  CNY: CHN,
  CZK: CZE,
  DKK: DNK,
  EUR: EUR,
  GBP: GBR,
  HKD: HKG,
  HRK: HRV,
  HUF: HUN,
  ILS: ISR,
  JPY: JPN,
  KRW: KOR,
  MXN: MEX,
  NOK: NOR,
  NZD: NZL,
  PLN: POL,
  RON: ROU,
  RUB: RUS,
  SAR: SAU,
  SEK: SWE,
  SGD: SGP,
  TRY: TUR,
  USD: USA,
  ZAR: ZAF,
};

interface CurrencyFlagProps
  extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src" | "alt"> {
  currency: keyof typeof currencyMap;
}

/**
 * Generates flag associated with currency code. If there's no flag assigned,
 * currency code itself is returned.
 */
export const CurrencyFlag = ({ currency, ...props }: CurrencyFlagProps) => {
  const src = currencyMap[currency];
  if (!src) return currency;
  return <img src={src} alt={currency} {...props} />;
};
